import React from 'react';
import ReactDOM from 'react-dom';

import { useArrowClass } from '../../../hooks/tooltip/use-arrow-class';
import { usePositioning } from '../../../hooks/tooltip/use-positioning';
import { PopoverContent } from './index';

const popoverContentType = (<PopoverContent />).type;

export const PopoverContentChild = React.forwardRef(({ children, containerId, position: positionProp }, ref) => {
  const { position, ref: popoverRef, style } = usePositioning(ref, positionProp);

  const arrowClass = useArrowClass(position);

  const popoverContentChild = React.Children.toArray(children).find((child) => child.type === popoverContentType);

  const popoverContentProps = {
    arrowClass,
    position,
    ref: popoverRef,
    style,
  };

  const popoverContent = React.cloneElement(popoverContentChild, popoverContentProps);

  return ReactDOM.createPortal(popoverContent, global.document.getElementById(containerId));
});
